module.exports = __webpack_public_path__ + "static/media/featureImg.89001752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/Features/featureImg.jpg
// module id = 1018
// module chunks = 2